<div *ngIf="products">
    <ngx-slick-carousel class="carousel" [config]="slideConfig" #slickModal="slick-carousel">
        <div ngxSlickItem *ngFor="let product of products" class="slide">
            <cs-category-card [bgUrl]="product.primaryImageUrl" ratio="one_by_one" [text1]="product.name"
                [text2]="product.description " [showButton]="true">
            </cs-category-card>
        </div>
    </ngx-slick-carousel>
</div>